import { numberWithCommas, unlimitedParse } from '@callrail/looky/util';

import { platformDisplayInfo } from '../interfaces/plan-display-info';
import { PlatformPricing } from '../interfaces/platform-pricing';
import { ProductType } from '../type-aliases/product-type';
import { PlatformModel } from './platform.model';

export class ConvertAssistPlatformModel extends PlatformModel {
  public analysis_minutes: PlatformPricing;

  public platform: ProductType = 'convert_assist';
  public platformInfo = platformDisplayInfo[this.platform];

  public displayText;

  constructor(platformPlan) {
    super(platformPlan);
    Object.assign(this, platformPlan);
    this.setDisplayText();
  }

  public get _usageInfo(): string[] {
    return [
      `${this.analysis_minutes.included_units} analysis minutes per month; \
      $${this.analysis_minutes.additional_price} each additional`,
    ];
  }

  public get _unitPrice(): number {
    return this.price;
  }

  private setDisplayText() {
    this.displayText = {
      marketingCopyA: `${numberWithCommas(
        unlimitedParse(this.analysis_minutes?.included_units)
      )} included anaysis minutes`,
      // marketingCopyB: `Automation Rules`,
      // marketingCopyC: `Keyword analysis`,
    };
  }
}
